import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import KotaService from "../../../services/ref/kotaService";

export const initialState = {
    loading: false,
    data_kota: [],
    data_kecamatan: [],
    data_kelurahan: [],
    show_message:false,
    message:'',
}

export const getDataKota = createAsyncThunk('kota/data',async (data, { rejectWithValue }) => {
    try {
        const response = await KotaService.data(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataKecamatan = createAsyncThunk('kota/kecamatan',async (data, { rejectWithValue }) => {
    try {
        const response = await KotaService.data(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataKelurahan = createAsyncThunk('kota/kelurahan',async (data, { rejectWithValue }) => {
    try {
        const response = await KotaService.data(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const KotaSlice = createSlice({
    name: 'kota',
    initialState,
    reducers: {
        showLoadingKota: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKota.fulfilled, (state, action) => {
                state.loading = false
                state.data_kota = action.payload??[]
            })
            .addCase(getDataKota.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKota.rejected, (state, action) => {
                state.loading = false
                state.data_kota = action.payload??[]
            })
            .addCase(getDataKecamatan.fulfilled, (state, action) => {
                state.loading = false
                state.data_kecamatan = action.payload??[]
            })
            .addCase(getDataKecamatan.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKecamatan.rejected, (state, action) => {
                state.loading = false
                state.data_kecamatan = action.payload??[]
            })
            .addCase(getDataKelurahan.fulfilled, (state, action) => {
                state.loading = false
                state.data_kelurahan = action.payload??[]
            })
            .addCase(getDataKelurahan.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKelurahan.rejected, (state, action) => {
                state.loading = false
                state.data_kelurahan = action.payload??[]
            })
    },
})

export const {
    showLoadingAgama,
} = KotaSlice.actions

export default KotaSlice.reducer
